import { useInViewport as useMantineInViewport } from '@mantine/hooks';

export const useInViewport = useMantineInViewport;
